import { SVGProps } from 'react';



interface ISuccessIndicatorIconProps {
    checkmarkStrokeWidth?: number
}

function SuccessIndicatorIcon(props: SVGProps<SVGSVGElement> & ISuccessIndicatorIconProps) {
    const {checkmarkStrokeWidth = 2, ...rest} = props;

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 44 44"
            width="1em"
            height="1em"
            {...rest}
        >
            <g transform="translate(-661 -282)">
                <rect
                    width={44}
                    height={44}
                    rx={22}
                    transform="translate(661 282)"
                    fill="currentColor"
                />
                <path
                    d="M676.148 304.575l6.333 4.733 8.342-8.907"
                    fill="none"
                    stroke="#fff"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={checkmarkStrokeWidth}
                />
            </g>
        </svg>
    );
}

export default SuccessIndicatorIcon;
